<script lang="ts">
import Vue from 'vue'
import Card from "@/components/ui/Card.vue";
import BaseHeader from "@/views/organizations/components/BaseHeader.vue";
import Checkbox from "@/components/ui/Checkbox.vue";
import { getTariffs, updateTariff } from "@/api/organizations/tariffs"
import TariffOsagoItem from "@/views/organizations/tariffs/components/TariffOsagoItem.vue";
import TariffTourismItem from "@/views/organizations/tariffs/components/TariffTourismItem.vue";
import TariffGreenCardItem from "@/views/organizations/tariffs/components/TariffGreenCardItem.vue";

export default Vue.extend({
    name: "Index",
    components: {Checkbox, BaseHeader, TariffOsagoItem, TariffTourismItem, TariffGreenCardItem, Card},
    data() {
        return {
            tariffs: [],
        }
    },
    methods: {
        getTariffs() {
            const id = this.$route.params.branchId || this.$route.params.regionId || this.$route.params.organizationId

            getTariffs(id).then(response => {
                this.tariffs = response.data.data
                this.tariffs = this.tariffs.map(item => {
                    const allActive = item.tariffs.every(obj => obj.isActive === true);

                    return {...item, allActive: allActive}
                })
            })
        },
        getComponentByType(typeId) {
            switch (typeId) {
                case 1:
                    return 'TariffOsagoItem';
                case 3:
                    return 'TariffGreenCardItem'
                case 5:
                    return 'TariffTourismItem'
            }
        },
        async toggleAllActive(item, value) {
            const promises = item.tariffs.map(tariff => {
                return updateTariff(tariff.id, {isActive: value})
            })
            await Promise.all(promises);
            this.$message('Тариф оновлено');
            await this.getTariffs();
        },
    },
    created() {
        this.getTariffs();
    }
})
</script>

<template>
 <div>
     <BaseHeader/>
     <Card class="w-100 mt-4" v-for="item in tariffs" :key="item.companyId">
         <template #title>
             <div class="d-flex justify-content-between">
                 <div>
<!--                     <svg width="88" height="24" viewBox="0 0 88 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                         <path d="M18.2027 1.86572H17.9593C16.6953 1.86572 16.2087 2.17481 15.6798 3.31163C15.6322 3.42688 10.6712 14.926 10.2746 15.7485C10.2269 15.8428 10.1635 15.9948 10.1 16.1624C10.0101 15.9476 9.92547 15.759 9.87787 15.67C9.56053 15.0412 6.26025 7.31406 4.54134 3.28543C4.05476 2.3215 3.59464 1.86572 2.27769 1.86572H2.0344C1.24635 1.86572 0.876126 2.24816 0.722747 2.47866C0.453012 2.89253 0.442435 3.45308 0.701592 4.03459C0.981905 4.58466 8.99991 21.7941 9.07924 21.9617C9.39658 22.6794 9.89374 22.758 10.0947 22.758C10.2957 22.758 10.7929 22.6794 11.1049 21.9722C11.1842 21.7993 19.1811 4.68419 19.5724 3.87218C19.7945 3.43212 19.7788 2.97635 19.5354 2.58867C19.271 2.15385 18.7368 1.86572 18.2027 1.86572Z" fill="#453F9B"/>-->
<!--                         <path d="M37.0576 1.86572H36.9782C35.9893 1.86572 35.1853 2.66202 35.1853 3.64167V14.0092C35.1853 17.9122 32.5091 19.2952 30.219 19.2952C27.9289 19.2952 25.2528 17.9122 25.2528 14.0092V3.64167C25.2528 2.66202 24.4488 1.86572 23.4598 1.86572H23.3381C22.3491 1.86572 21.5452 2.66202 21.5452 3.64167V14.1716C21.5452 20.5053 26.0249 22.7633 30.219 22.7633C32.2447 22.7633 38.8505 22.1451 38.8505 14.1716V3.64167C38.8505 2.66202 38.0467 1.86572 37.0576 1.86572Z" fill="#453F9B"/>-->
<!--                         <path d="M48.9736 8.73339C48.7092 8.61813 48.4923 8.52908 48.3601 8.46622C47.7519 8.1676 46.948 7.66992 46.948 6.82647C46.948 5.60059 48.2121 4.85145 49.1164 4.85145C50.1743 4.85145 50.4281 5.061 50.7772 5.34914L50.9042 5.44867C51.0046 5.52725 51.1104 5.62155 51.2267 5.72108C51.8455 6.26592 53.0038 7.277 54.2467 6.40737C55.0664 5.88349 55.3151 4.91955 54.8232 4.11278C54.0246 2.83451 51.8244 1.84962 50.1161 1.47767C49.5079 1.34146 48.3443 1.32574 47.2653 1.56672C46.4615 1.79199 45.7421 2.01202 45.0916 2.45732C43.5948 3.48936 42.7381 5.08195 42.7381 6.82647C42.7381 9.1944 44.1291 10.4517 45.1868 11.2009C46.0013 11.7457 46.8476 12.0339 47.7413 12.3377C48.5294 12.6049 49.3492 12.8825 50.1848 13.3592C52.2105 14.5379 52.8293 15.2871 52.7235 16.4292C52.6071 17.7546 51.1633 19.2948 49.4655 19.2948C47.826 19.2948 46.636 18.729 45.594 17.4455C45.5358 17.3774 45.4724 17.2831 45.4036 17.1836C44.9858 16.5811 44.0126 15.1667 42.2779 15.9629C40.7917 16.6492 41.1461 18.0428 41.4052 18.5037C43.2246 21.3694 45.8585 22.7629 49.4602 22.7629C52.0413 22.7629 54.2044 21.7884 55.5372 20.0125C56.9176 18.1789 57.2085 15.6853 56.283 13.6474C55.2781 11.4262 51.0205 9.60826 48.9736 8.73339Z" fill="#453F9B"/>-->
<!--                         <path d="M69.2353 1.38281C63.2853 1.38281 58.4459 6.1763 58.4459 12.0699C58.4459 17.9636 63.2853 22.757 69.2353 22.757C75.2065 22.757 80.067 17.9636 80.067 12.0699C80.067 6.1763 75.2118 1.38281 69.2353 1.38281ZM69.2353 19.289C65.3744 19.289 62.1058 15.9834 62.1058 12.0699C62.1058 8.15656 65.3691 4.85089 69.2353 4.85089C73.165 4.85089 76.3647 8.08846 76.3647 12.0699C76.3647 16.0514 73.165 19.289 69.2353 19.289Z" fill="#453F9B"/>-->
<!--                         <path d="M78.7557 12.7722C73.0119 9.33028 68.4529 12.484 69.1722 14.1866C73.9269 11.7506 75.1645 16.6541 80.7761 16.8427C85.8005 16.6646 87.5829 13.8042 87.456 11.2738C87.3502 9.29884 85.0125 16.5179 78.7557 12.7722Z" fill="#FFCE6B"/>-->
<!--                     </svg>-->
                     <img :src="item.logo" alt="" width="88" height="24">
                     {{ item.name }}
                 </div>
                 <div class="select-all">
                     <div>
                         <Checkbox v-model="item.allActive" @change="toggleAllActive(item, $event)"></Checkbox>
                     </div>
                     <div>
                         Усі продукти
                     </div>
                 </div>
             </div>
         </template>
        <div class="row" v-for="tariff in item.tariffs">
            <div class="col-12 mt-4">
                <Component :is="getComponentByType(tariff.productId)" :tariff.sync="tariff" @update:tariff="$message('Тариф оновлено'); getTariffs()"></Component>
            </div>
        </div>
     </Card>
 </div>
</template>

<style scoped lang="scss">
.select-all {
    display: flex;
    align-items: center;
    gap: 3px;
    font-family: Inter, serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    /* identical to box height, or 129% */

    color: #09090B;
    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;

}
</style>
